module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"current-profile":"Текущий профиль","profiles:menu-title":"Меню профилей","profiles:menu-settings":"Настройки профилей"},"en":{"current-profile":"Current profile","profiles:menu-title":"Profiles menu","profiles:menu-settings":"Profiles settings"}}')
  delete Component.options._Ctor
}
